import {
  agentOverviewList,
  agentsContinuousCompensationList,
  annualInspectionDueList,
  agentsNotMailedStopFeedingList,
  agentsNotCompensationStopFeedingList,
  agentsNotDepositPaidStopFeedingList,
  insuranceExpiresDueList,
  moreOneMonthStopFeedingList,
  agentContractDetailsList
} from '@/api/informationPush/information-push'

export const option = {
  height: 'auto',
  tip: false,
  searchShow: false,
  searchSpan: 6,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  menu: false,
  header:false,
  column: [],
};

export const requestMessage = {
  1: {
    title: '未邮寄资料停止进件的代理商__企业微信消息通知',
    api: agentsNotMailedStopFeedingList,
  },
  2: {
    title: '未履行代偿停止进件的代理商__企业微信消息通知',
    api: agentsNotCompensationStopFeedingList
  },
  3: {
    title: '未缴纳保证金停止进件的代理商__企业微信消息通知',
    api: agentsNotDepositPaidStopFeedingList
  },
  4: {
    title: '连续代偿的代理商__企业微信消息通知',
    api: agentsContinuousCompensationList,
  },
  5: {
    title: '代理商概况__企业微信消息通知',
    api: agentOverviewList,
  },
  6: {
    title: '年检到期未处理__企业微信消息通知',
    api: annualInspectionDueList,
  },
  7: {
    title: '保险到期未处理__企业微信消息通知',
    api: insuranceExpiresDueList
  },
  8: {
    title: '一个月以上未进件的代理商__企业微信消息通知',
    api: moreOneMonthStopFeedingList
  },
  9: {
    title: '代理商签约明细__企业微信消息通知',
    api: agentContractDetailsList
  },
}

export const data = [{
  isDescription: true, // 是否是 有描述信息
  span:12, // 列宽度 总分为24份
  omit: true,
  omitLength: 50,
  spanArr:[  // 需要合并的 单元格
    {prop: '需要合并的单元格字段名', span: []},
  ],
  descriptionObj:[
    {
      label:'描述列表左侧label',
      value: '描述列表值'
    }
  ],
  column:[  // 表头
    {
      label: '表头名称',
      prop: '表头字段名',
    },
  ],
  tableList: [ // 数据值
    {
      valueKey: 'value', // 字段名： 字段值
    },
  ],
}]
